/** @jsx jsx */
import React, { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import { css as cssString } from '@emotion/css';
import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Page from 'Components/Page';
import CenteredSpinner from 'Components/CenteredSpinner';
import TokensNavbar from 'Components/TokensNavbar';
import Container from 'Components/Container';
import { MainContent } from './MainContent';
import { InfoArea } from './InfoArea';
import { InfoRow } from './InfoRow';
import QrCodePlaceholder from 'Images/qr-code-placeholder.png';
import { Star } from './Star';
import { AuthenticityInfoRow } from './AuthenticityInfoRow';
import horizontalLogo from 'Images/logo-horizontal-2.png';
import useDetectPrint from 'use-detect-print';
import Footer from 'Components/Footer';

function Certificate({ tokenId, contractAddress }) {
  const theme = useTheme();
  const [tokenInfo, setTokenInfo] = useState(null);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isPrinting = useDetectPrint();

  useEffect(() => {
    if (!tokenInfo) {
      const getTokenInformation = async () => {
        setTokenInfo({
          name: `Original Andy Warhol Digital Painting of Deborah Harry Original File`,
          description: ``,
          image:
            'https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2FDebbie_Harry_Andy_Warhol_Watermarked.png?alt=media&token=5abfe06c-2c08-43d6-9f14-a0073cb290bf',
          owners: [
            {
              owner: {
                user: null,
                profile_img_url: 'https://storage.googleapis.com/opensea-static/opensea-profile/1.png',
                address: '0xabab501a39e2328c23e169197f714a5216136823',
                config: '',
                discord_id: '',
              },
              quantity: '1',
            },
          ],
        });

        setTimeout(function () {
          const videoPlayer = document.getElementById('token-video');
          if (videoPlayer) {
            videoPlayer.play();
          }
        }, 1000);
      };

      getTokenInformation();
    }
  }, [contractAddress, tokenId, tokenInfo]);

  const ownerfySmartContractAddress = '0x559604845ffc64a05f780ead75249c377b1dae57';
  const digitalAndyAddress = '0x559604845ffc64a05f780ead75249c377b1dae57';

  const CertificatePageNavbar = () => (
    <TokensNavbar
      css={css`
        @media print {
          display: none;
        }
      `}
    />
  );

  const CertificatePageFooter = () => (
    <Footer
      css={css`
        @media print {
          display: none;
        }
      `}
    />
  );

  return (
    <Page
      hasContainer={false}
      isContainerPadded={false}
      NavBarComponent={CertificatePageNavbar}
      FooterComponent={CertificatePageFooter}
      wrapperStyles={cssString`
        padding-bottom: 0 !important;
      `}
    >
      {tokenInfo ? (
        <div
          css={css`
            padding-bottom: 37px;
            ${theme.breakpoints.up('sm')} {
              padding-bottom: 50px;
            }
            & a {
              color: #08be64;
              text-decoration: none;
            }
          `}
        >
          <div
            css={css`
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              @media screen {
                display: none;
              }
            `}
          >
            <img
              css={css`
                max-width: 130px;
                max-height: 40px;
                height: auto;
                ${theme.breakpoints.up('sm')} {
                  max-width: 218px;
                  max-height: 60px;
                }
              `}
              src={horizontalLogo}
              alt="logo"
            />
          </div>
          <div>
            <div
              css={css`
                background-color: #fdfdfd;
                border-bottom: 1px solid #ededed;
                padding: 13px 0;
                ${theme.breakpoints.up('sm')} {
                  padding: 20px 0;
                }
              `}
            >
              <Container>
                <Typography
                  variant="h1"
                  css={css`
                    color: #04a542;
                    margin: 0;
                    font-family: 'Work Sans', sans-serif;
                    font-weight: 600;
                    font-size: 24px;
                    letter-spacing: 0.18px;
                    line-height: 28px;
                    text-align: center;
                    ${theme.breakpoints.up('sm')} {
                      font-size: 34px;
                      letter-spacing: 0.26px;
                      line-height: 40px;
                    }
                  `}
                >
                  NFT Certificate of Authenticity
                </Typography>
              </Container>
            </div>

            <div
              css={css`
                padding: 30px 0;
                ${theme.breakpoints.up('sm')} {
                  padding: 36px 0;
                }
              `}
            >
              <Container isCentered>
                <a href="/nft/andy-warhol-deborah-harry-original-nft">
                  <Typography
                    variant="h1"
                    css={css`
                      color: #4d5153;
                      margin: 0;
                      font-family: Avenir Next;
                      font-weight: bold;
                      font-size: 20px;
                      letter-spacing: 0.15px;
                      line-height: 27px;
                      text-align: center;
                      ${theme.breakpoints.up('sm')} {
                        font-size: 26px;
                        letter-spacing: 0.2px;
                        line-height: 36px;
                      }
                    `}
                  >
                    {tokenInfo.name}
                  </Typography>
                </a>
                <div
                  css={css`
                    display: flex;
                    margin-top: 10px;
                    max-width: 651px;
                    margin: 0 auto;
                    margin-top: 24px;
                    ${theme.breakpoints.up('sm')} {
                      margin-top: 30px;
                      flex-direction: row;
                    }
                  `}
                >
                  <a href="/nft/andy-warhol-deborah-harry-original-nft">
                    <MainContent animationUrl={tokenInfo.animation_url} imageSrc={tokenInfo.image} />
                  </a>
                  <img
                    css={css`
                      display: none;
                      ${theme.breakpoints.up('sm')} {
                        display: block;
                        margin-left: 60px;
                      }
                      @media print {
                        display: block;
                        margin-left: 60px;
                      }
                    `}
                    src={QrCodePlaceholder}
                    alt="qr code"
                    width="157"
                    height="157"
                  />
                </div>
              </Container>
            </div>
          </div>

          <div
            css={css`
              flex: 1;
              width: 100%;
            `}
          >
            <Container>
              <InfoArea
                title="NFT Info"
                css={css`
                  margin: 0 auto;
                  max-width: 651px;
                `}
              >
                <InfoRow label="Token ID" info="1" isContentStacked={isMobile && !isPrinting} />
                <InfoRow label="Blockchain" info="Ethereum" isContentStacked={isMobile && !isPrinting} />
                <InfoRow
                  label="Smart Contract"
                  info={
                    <span>
                      Ownerfy{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://etherscan.io/address/${ownerfySmartContractAddress}`}
                      >
                        {ownerfySmartContractAddress}
                      </a>
                    </span>
                  }
                  isContentStacked={isMobile && !isPrinting}
                />
                <InfoRow
                  label="Owned by"
                  info={
                    <span>
                      Digital Andy NFT, LLC{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://etherscan.io/address/${digitalAndyAddress}`}
                      >
                        {digitalAndyAddress}
                      </a>
                    </span>
                  }
                  isContentStacked={isMobile && !isPrinting}
                />
                <InfoRow
                  label="Created by"
                  info={
                    <span>
                      Digital Andy NFT, LLC{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://etherscan.io/address/${digitalAndyAddress}`}
                      >
                        {digitalAndyAddress}
                      </a>
                    </span>
                  }
                  isContentStacked={isMobile && !isPrinting}
                />
                <InfoRow label="Created" info="Apr 13, 2021" isContentStacked={isMobile && !isPrinting} />
              </InfoArea>

              <InfoArea
                title={
                  <>
                    NFT Authenticity Rating
                    <Star
                      css={css`
                        margin-left: 5px;
                        ${theme.breakpoints.up('sm')} {
                          margin-left: 10px;
                        }
                      `}
                    />
                    <Star />
                    <Star />
                    <Star />
                    <Star />
                  </>
                }
                css={css`
                  margin: 0 auto;
                  margin-top: 30px;
                  max-width: 651px;
                `}
              >
                <AuthenticityInfoRow
                  label="NFT"
                  criterias={[
                    {
                      label: 'token exists on the blockchain',
                      isVerified: true,
                    },
                    {
                      label: 'ERC-1155 standard',
                      isVerified: true,
                    },
                  ]}
                  css={css`
                    margin-top: -12px;
                  `}
                />

                <AuthenticityInfoRow
                  label="Smart Contract  "
                  criterias={[
                    {
                      label: 'source code published',
                      isVerified: true,
                    },
                  ]}
                />

                <AuthenticityInfoRow
                  label="Creator"
                  criterias={[
                    {
                      label: 'verified address',
                      isVerified: true,
                    },
                    {
                      label: 'unique creator',
                      isVerified: true,
                    },
                  ]}
                />

                <AuthenticityInfoRow
                  label="Data Integrity"
                  criterias={[
                    {
                      label: 'on-chain image hashing',
                      isVerified: true,
                    },
                    {
                      label: 'off-chain metadata hash (ipfs)',
                      isVerified: false,
                    },
                  ]}
                />

                <AuthenticityInfoRow
                  label="Availability"
                  criterias={[
                    {
                      label: 'links are active',
                      isVerified: true,
                    },
                  ]}
                  css={css`
                    border: none !important;
                    margin-bottom: -14px;
                  `}
                />
              </InfoArea>

              <img
                css={css`
                  margin-top: 48px;
                  ${theme.breakpoints.up('sm')} {
                    display: none;
                  }
                  @media print {
                    display: none;
                  }
                `}
                src={QrCodePlaceholder}
                alt="qr code"
                width="100%"
                height="auto"
              />
            </Container>
          </div>
        </div>
      ) : (
        <CenteredSpinner />
      )}
    </Page>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    tokenId: ownProps.match.params.tokenId,
    contractAddress: ownProps.match.params.contractAddress,
  };
}

export default withRouter(connect(mapStateToProps, null)(Certificate));
